import { createGlobalStyle } from 'styled-components';

/** Reusable global style for Ant Design Image preview overlays. */
export const GlobalImagePreviewStyles = createGlobalStyle`
    .global-image-preview-root .ant-image-preview-mask {
        backdrop-filter: blur(22px) saturate(1.25);
        -webkit-backdrop-filter: blur(22px) saturate(1.25);
        background: rgba(15, 23, 42, 0.55) !important;
    }
    .global-image-preview-root .ant-image-preview-operations {
        background: rgba(255, 255, 255, 0.12) !important;
        backdrop-filter: blur(14px);
        -webkit-backdrop-filter: blur(14px);
        border: 1px solid rgba(255, 255, 255, 0.14);
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
    }
    .global-image-preview-root .ant-image-preview-close {
        background: rgba(255, 255, 255, 0.12) !important;
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.12);
    }
`;

